module.exports = __webpack_public_path__ + "static/media/drapcode.bb066e37.png";